(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bs-comparison"] && !Shopify.designMode) return;
  try {
    
(function () {
  document.querySelectorAll('[data-bs-slider]').forEach(function (slider) {
    var slides = slider.querySelectorAll('[data-bs-slide]');
    if (slides.length < 2) return;
    var section = slider.closest('.bs-comparison');
    var dots = section.querySelectorAll('[data-bs-dot]');
    var prevBtn = section.querySelector('[data-bs-prev]');
    var nextBtn = section.querySelector('[data-bs-next]');
    var autoplay = parseInt(slider.dataset.autoplay, 10) || 0;
    var current = 0, timer = null, paused = false;
    function go(index) { current = (index + slides.length) % slides.length; slides.forEach(function (s, i) { s.classList.toggle('is-active', i === current); }); dots.forEach(function (d, i) { d.classList.toggle('is-active', i === current); d.setAttribute('aria-selected', i === current ? 'true' : 'false'); }); }
    function next() { go(current + 1); }
    function prev() { go(current - 1); }
    function startAutoplay() { if (!autoplay) return; stopAutoplay(); timer = setInterval(function () { if (!paused) next(); }, autoplay * 1000); }
    function stopAutoplay() { if (timer) { clearInterval(timer); timer = null; } }
    if (prevBtn) prevBtn.addEventListener('click', function () { prev(); startAutoplay(); });
    if (nextBtn) nextBtn.addEventListener('click', function () { next(); startAutoplay(); });
    dots.forEach(function (dot) { dot.addEventListener('click', function () { var i = parseInt(dot.dataset.index, 10); if (!isNaN(i)) { go(i); startAutoplay(); } }); });
    section.addEventListener('mouseenter', function () { paused = true; });
    section.addEventListener('mouseleave', function () { paused = false; });
    var startX = 0, deltaX = 0;
    slider.addEventListener('touchstart', function (e) { startX = e.touches[0].clientX; deltaX = 0; }, { passive: true });
    slider.addEventListener('touchmove', function (e) { deltaX = e.touches[0].clientX - startX; }, { passive: true });
    slider.addEventListener('touchend', function () { if (Math.abs(deltaX) > 40) { if (deltaX < 0) next(); else prev(); startAutoplay(); } });
    startAutoplay();
  });
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-bs-quick-add]');
    if (!btn) return;
    e.preventDefault();
    var variantId = btn.dataset.variantId;
    if (!variantId) { window.location = btn.href; return; }
    btn.setAttribute('disabled', 'disabled');
    var originalText = btn.innerText;
    btn.innerText = 'Adding...';
    fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] }) })
      .then(function (r) { return r.json(); })
      .then(function () { btn.innerText = '✓ Added'; document.dispatchEvent(new CustomEvent('cart:refresh')); document.dispatchEvent(new CustomEvent('cart:open')); var openCartBtn = document.querySelector('[data-cart-drawer-open], .m-cart-drawer-open, [aria-controls*="cart"]'); if (openCartBtn) openCartBtn.click(); setTimeout(function () { btn.innerText = originalText; btn.removeAttribute('disabled'); }, 1500); })
      .catch(function () { btn.innerText = 'Try again'; btn.removeAttribute('disabled'); setTimeout(function () { btn.innerText = originalText; }, 1500); });
  });
})();

  } catch(e) { console.error(e); }
})();
})();
